
  import { defineComponent, ref, onMounted, computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import Datatable from '@/components/kt-datatable/KTDatatable.vue';
  import Factors from '@/store/enums/IREFactorsEnums';
  import Tabs from '@/components/tabs.vue';

  export default defineComponent({
    name: 'ire-factors-general-specs-listing',
    components: {
      Datatable,
      Tabs,
    },
    async setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const router = useRouter();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('IreFactorsGeneralspecsListing'), [
          translate('ire'),
        ]);
      });

      await store.dispatch(Actions.GET_IRE_FACTORS, Factors.GENERALSPECS);
      const loading = ref(false);
      const tableHeader = ref([
        {
          name: translate('idColumn'),
          key: 'id',
          sortable: true,
        },
        {
          name: translate('titleEn'),
          key: 'titleEn',
          sortable: true,
        },
        {
          name: translate('titleAr'),
          key: 'titleAr',
          sortable: true,
        },
        {
          name: translate('sort'),
          key: 'sort',
        },
        {
          name: translate('isActive'),
          key: 'isActive',
        },
        {
          name: translate('actions'),
          key: 'actions',
        },
      ]);
      const toggleStatusIreFactorsGeneralspecs = async (
        IreFactorsGeneralspecs
      ) => {
        const deletedMessage = IreFactorsGeneralspecs.isActive
          ? 'confirmInActive'
          : 'confirmActive';
        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          text: translate(deletedMessage),
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-warning',
            cancelButton: 'btn btn-light',
          },
        });

        if (result.value) {
          loading.value = true;
          await store.dispatch(
            Actions.DELETE_IRE_FACTOR,
            IreFactorsGeneralspecs.id
          );
          await store.dispatch(Actions.GET_IRE_FACTORS, Factors.GENERALSPECS);
          loading.value = false;
          const [errorName] = Object.keys(store.getters.getErrors);
          const error = store.getters.getErrors[errorName];
          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
          } else {
            const SuccessMsg = IreFactorsGeneralspecs.isActive
              ? 'SUCCESSFULLY_INACTIVATED'
              : 'SUCCESSFULLY_ACTIVEATED';
            Swal.fire({
              text: translate(SuccessMsg),
              icon: 'success',
              buttonsStyling: false,
              confirmButtonText: translate('ok'),
              customClass: {
                confirmButton: 'btn btn-light-primary',
              },
            });
          }
        }
      };

      const editIreFactorsGeneral = (id) => {
        router.push({
          name: 'ire-factors-general-specs-editing',
          params: { id },
        });
      };

      const goTo = (pageName) => {
        router.push({ name: pageName });
      };

      const pageChanged = async (val) => {
        loading.value = true;
        await store.dispatch(Actions.UPDATE_IRE_FACTOR_CURRENT_PAGE, val);
        await store.dispatch(Actions.GET_IRE_FACTORS, Factors.GENERALSPECS);
        loading.value = false;
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        tableData: computed(() => store.getters.ireFactorsList),
        totalItems: computed(() => store.getters.ireFactorsListCount),
        tableHeader,
        toggleStatusIreFactorsGeneralspecs,
        translate,
        pageChanged,
        goTo,
        editIreFactorsGeneral,
        loading,
        can,
      };
    },
  });
